import {Draft, isDraft, original} from "@reduxjs/toolkit";

export function safeGetOriginal<T>(value: Draft<T> | T): T {
    return isDraft(value)
        ? original(value) as T
        : value as T;
}
